import { action, observable } from "mobx";
import { buildParamString, IAPIResponse } from "@mindmemobile/mm-shared-global";
import { ProgramAndLevelsModel } from "../../../shared/models";
import { AuthService, HttpService, url } from "../../../shared/services";
import { IAPIProgramAndLevelsModels } from "../../../shared/interfaces";

export default class ProgramAndLevelsService {
  @observable public programAndLevels: ProgramAndLevelsModel[] = [];
  private httpService: HttpService;
  constructor() {
    this.httpService = new HttpService(
      undefined,
      `${process.env.REACT_APP_API_KEY}`,
      process.env.REACT_APP_API_BASE_URL
    );

    AuthService.hasAccount &&
      this.loadProgramAndLevels(AuthService.authData.accountId);
  }

  @action
  loadProgramAndLevels(accountId: string) {
    const params: string = buildParamString({
      accountId: accountId,
    });

    this.httpService
      .get<
        IAPIResponse<IAPIProgramAndLevelsModels[]>
      >(url.getAllProgramAndLevels, params)
      .subscribe({
        next: (d) => {
          this.programAndLevels = ProgramAndLevelsModel.deserializeAPIModel(
            d.result
          );
        },
      });
  }
}
